/**
 * ComponentRegistryService 实现
 *
 * 组件注册服务的核心实现，负责组件的注册、存储、查找和卸载。
 */
/**
 * 组件注册服务
 *
 * ui-registry-mod 的核心服务之一，业务 Mod 通过此服务注册可跨模块共享的组件。
 */
export class ComponentRegistryService {
    constructor(deps) {
        this.components = {};
        this.modRegistry = new Map();
        this.eventBus = deps?.eventBusService;
    }
    registerComponents(modName, components) {
        // 校验组件名冲突
        for (const key of Object.keys(components)) {
            if (this.components[key]) {
                throw new Error(`Component conflict: ${key} already registered`);
            }
        }
        // 批量注册
        Object.assign(this.components, components);
        // 记录模块注册的组件名
        if (!this.modRegistry.has(modName)) {
            this.modRegistry.set(modName, new Set());
        }
        for (const key of Object.keys(components)) {
            this.modRegistry.get(modName).add(key);
        }
        if (this.eventBus) {
            this.eventBus.emit('component:registered', {
                modName,
                keys: Object.keys(components),
            });
        }
    }
    unregisterModComponents(modName) {
        const keys = this.modRegistry.get(modName);
        if (keys) {
            for (const key of keys) {
                delete this.components[key];
            }
            this.modRegistry.delete(modName);
        }
        if (this.eventBus) {
            this.eventBus.emit('component:unregistered', { modName });
        }
    }
    getComponents() {
        return { ...this.components };
    }
    getComponentsByMod(modName) {
        const keys = this.modRegistry.get(modName);
        if (!keys)
            return {};
        const result = {};
        for (const key of keys) {
            if (this.components[key]) {
                result[key] = this.components[key];
            }
        }
        return result;
    }
}
//# sourceMappingURL=component-registry.js.map